module.exports = __webpack_public_path__ + "img/discover.d5e00205.svg";